import Dexie from 'dexie';
// import 'dexie-observable';
/**
 * * MODELS
 */
import { ISessionData } from './models/ISessionData.model';
import { IUser } from './models/IUser.model';
import { IUsersList } from './models/IUsersList.model';
import { ICurrentUser } from './models/ICurrentUser.model';
import { ITiposDictamen } from './models/ITiposDictamen.model';
import { IEspecialidades} from './models/IEspecialidades.model';
import { IMotivosCierre } from './models/IMotivosCierre.model';
import { IExamen } from './models/IExamen.model';
import { IExamenPorEnviar } from './models/IExamenPorEnviar.model';
import { INombresExamen } from './models/INombresExamen.model';
import { ITiposDocumento } from './models/ITiposDocumento.model';
import { ITiposExamen } from './models/ITiposExamen.model';
import { IExamenesCargados } from './models/IExamenesCargados.model';
import { IExamenPresentismoPorEnviar } from './models/IExamenPresentismoPorEnviar.model';
//
// Declare Database
//

export class DatabaseConnection extends Dexie {
  /**
   * * TABLE Interfaces
   */
  public sessionData: Dexie.Table<ISessionData, number>; // id is number in this case
  public usuarios: Dexie.Table<IUser[], number>;
  public offlineUsers: Dexie.Table<IUsersList, number>;
  public currentUser: Dexie.Table<ICurrentUser, number>;
  public motivosCierre: Dexie.Table<IMotivosCierre, number>;
  public tiposDictamen: Dexie.Table<ITiposDictamen, number>;
  public nombresExamen: Dexie.Table<INombresExamen, number>;
  public tiposDocumento: Dexie.Table<ITiposDocumento, number>;
  public tiposExamen: Dexie.Table<ITiposExamen, number>;
  public especialidades: Dexie.Table<IEspecialidades, number>;
  public tiposCaracterizacionSemiologica: Dexie.Table<ITiposDictamen, number>;

  public examenesPeriodicos: Dexie.Table<IExamen[], number>;
  public examenesReevaluacion: Dexie.Table<IExamen[], number>;
  public examenesPeriodicosFiltrados: Dexie.Table<IExamen[], number>;
  public examenesReevaluacionFiltrados: Dexie.Table<IExamen[], number>;
  public examenesCargados: Dexie.Table<IExamenesCargados[], number>;
  public examenesPorEnviar: Dexie.Table<IExamenPorEnviar, number>;
  public examenesPresentismoPorEnviar: Dexie.Table<IExamenPresentismoPorEnviar, number>;

  constructor() {
    super('provincia-art-offline-db');

    /**
     * * en el objeto 'STORE' deben declararse los nombres de las tablas
     * * y cuales son aquellas key que se desea indexar
     */
    this.version(1).stores({
      sessionData: '++id,lastUpdate,isStillOnline,baseApiUrl',
      usuarios: '++id,token,modelId,userId',
      offlineUsers: '++id,expirationDate',
      currentUser: '++id,token,modelId,userId',
      motivosCierre: '++id,codigo,descripcion',
      tiposDictamen: '++id,codigo,descripcion',
      nombresExamen: '++id,codigo,descripcion',
      tiposDocumento: '++id,codigo,descripcion',
      tiposExamen: '++id,codigo,descripcion',
      tiposCaracterizacionSemiologica: '++id,codigo,descripcion',
      especialidades: '++id,codigo,descripcion',
      examenesPeriodicos:
        '++id,fechaAsignacion,tipoEstudio.descripcion,lote.empresa.cuit,trabajador.numeroDocumento',
      examenesReevaluacion:
        '++id,fechaAsignacion,tipoEstudio.descripcion,lote.empresa.cuit,trabajador.numeroDocumento',
      examenesPeriodicosFiltrados:
        '++id,fechaAsignacion,tipoEstudio.descripcion,lote.empresa.cuit,trabajador.numeroDocumento',
      examenesReevaluacionFiltrados:
        '++id,fechaAsignacion,tipoEstudio.descripcion,empresa.cuit,trabajador.numeroDocumento',
      examenesCargados:'++id,tipoEstudio.descripcion,lote.id,trabajador.tipoDocumento,trabajador.numeroDocumento,enviado',
      examenesPorEnviar: '++id,seModificoTrabajador,onOnlineSendTo,examenData.tipoEstudio.descripcion,examenData.fechaAsignacion',
      examenesPresentismoPorEnviar: '++id, examenDataToSend, onOnlineSendTo',
    });

    // this.on('changes', (changes) => {
    //   changes.forEach( (change) => {
    //     switch (change.type) {
    //       case 1: // CREATED
    //         // console.log('An object with key ' + change.key + ' was updated with modifications: ' + JSON.stringify(change.table));
    //         break;
    //       case 2: // UPDATED
    //         // console.log('An object with key ' + change.key + ' was updated with modifications: ' + JSON.stringify(change.table));
    //         break;
    //       case 3: // DELETED
    //         // console.log('An object with key ' + change.key + ' was updated with modifications: ' + JSON.stringify(change.table));
    //         break;
    //     }
    //   });
    // });

    /**
     * * en estas se exponen las tablas creadas
     */
    this.sessionData = this.table('sessionData');
    this.usuarios = this.table('usuarios');
    this.offlineUsers = this.table('offlineUsers');
    this.currentUser = this.table('currentUser');
    this.motivosCierre = this.table('motivosCierre');
    this.tiposDictamen = this.table('tiposDictamen');
    this.nombresExamen = this.table('nombresExamen');
    this.tiposDocumento = this.table('tiposDocumento');
    this.tiposExamen = this.table('tiposExamen');
    this.especialidades = this.table('especialidades');
    this.tiposCaracterizacionSemiologica = this.table('tiposCaracterizacionSemiologica');
    this.examenesPeriodicos = this.table('examenesPeriodicos');
    this.examenesReevaluacion = this.table('examenesReevaluacion');
    this.examenesPeriodicosFiltrados = this.table('examenesPeriodicosFiltrados');
    this.examenesReevaluacionFiltrados = this.table('examenesReevaluacionFiltrados');
    this.examenesCargados = this.table('examenesCargados');
    this.examenesPorEnviar = this.table('examenesPorEnviar');
  }
}
